export type Faq = {
  q: string
  a: string
}

export const FAQS: Faq[] = [
  {
    q: 'How does SPANISH TEACHER PRO™ work?',
    a: 'After your purchase, you receive immediate digital access to all six modules and five strategic bonuses. Access and use the resources from your computer, tablet or smartphone.',
  },
  {
    q: 'Is this a physical or digital product?',
    a: 'SPANISH TEACHER PRO™ is completely digital. No physical product will be shipped. Your access becomes available after payment confirmation.',
  },
  {
    q: 'Is this designed for experienced Spanish teachers?',
    a: 'Yes. SPANISH TEACHER PRO™ is designed for teachers and tutors who already understand the fundamentals of teaching and want structured resources, activities, lesson frameworks and ready-to-adapt teaching materials.',
  },
  {
    q: 'Can I use it with students at different levels?',
    a: "Yes. The resources are designed to be selected and adapted according to your student's proficiency, goals, communication needs and progress, from beginner through advanced levels.",
  },
  {
    q: 'Are the lessons identical for every student?',
    a: "No. SPANISH TEACHER PRO™ is not a rigid curriculum. The lesson structures and resources provide a professional starting point that you adapt according to each student's level, goals and learning needs.",
  },
  {
    q: 'Can I modify and adapt the material?',
    a: 'Yes. Each resource provides a professional base that you can adapt to your lessons, teaching style, objectives and students.',
  },
  {
    q: 'Are the five bonuses included?',
    a: 'Yes. During this offer, all five strategic bonuses are included at no additional cost.',
  },
  {
    q: 'How long will I have access?',
    a: 'Your purchase includes lifetime access to the digital resources included with your order.',
  },
  {
    q: 'Can I use it for online lessons, in-person classes and private tutoring?',
    a: 'Yes. The lesson frameworks, activities and speaking resources are structured for one-to-one lessons, small groups, classroom teaching and online sessions.',
  },
  {
    q: 'What makes SPANISH TEACHER PRO™ different from free resources online?',
    a: 'Free teaching resources are often scattered and disconnected. SPANISH TEACHER PRO™ brings lesson planning, grammar, vocabulary, speaking, activities, assessment and professional teaching tools together inside one coherent system designed to simplify your preparation.',
  },
]
